import {css} from "@emotion/react";


export const card = css`
    border: 1px #E7E9EB solid;
    border-radius: 10px;
    box-shadow: 0 0 7px rgba(0,0,0,0.12);
    background-color: white;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const detailsText = css`
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 8px;
    margin-top: 8px;
`;

export const cardContainer = css`
    display: flex;
    flex-direction: column;
`;